import { IBreakpoints, BreakpointsTypes } from "../../interfaces/IBreakpoints";

export const getActiveBreakPointName = (breakpoints: IBreakpoints): BreakpointsTypes | string => {
    let result: BreakpointsTypes | string;
    Object.keys(breakpoints).forEach((key: string) => {
        if (breakpoints[key]) {
            result = key;
        }
    });

    return result;
};

interface IBreakpointParams {
    [key: string]: IBreakpoints;
}

export interface IBreakpointResult {
    [key: string]: BreakpointsTypes | string;
}

export const getBreakPointNames = (params: IBreakpointParams): IBreakpointResult => {
    const result = {};

    Object.keys(params).forEach((key: string) => (result[key] = getActiveBreakPointName(params[key])));

    return result;
};
